/**
 * Width consumed by an element's vertical scrollbar, in pixels.
 * Overlay scrollbars report 0 because they do not take layout space.
 * @param el - Scroll container
 */
export function getVerticalScrollbarWidth(el: HTMLElement): number {
  return Math.max(0, el.offsetWidth - el.clientWidth)
}
